module.exports = __webpack_public_path__ + "static/media/403.3c0b4dce.png";